export const messages = {
  name: 'Message |||| Messages',
  fields: {
    id: 'ID',
    title: 'Title',
    content: 'Content',
    type: 'Type',
    priority: 'Priority',
    status: 'Status',
    targetType: 'Target Type',
    targetData: 'Target Data',
    membershipLevels: 'Membership Levels',
    targetUsers: 'Target Users',
    actionType: 'Action Type',
    actionData: 'Action Data',
    imageUrl: 'Image URL',
    image: 'Banner Image',
    imageHelp: 'Upload a banner image (2:1 aspect ratio)',
    sendPush: 'Send Push Notification',
    sendEmail: 'Send Email',
    deliveryTime: 'Delivery Time',
    scheduledAt: 'Scheduled At',
    sentAt: 'Sent At',
    expiresAt: 'Expires At',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    createdBy: 'Created By',
    totalRecipients: 'Total Recipients',
    totalReads: 'Total Reads',
    totalClicks: 'Total Clicks',
    readRate: 'Read Rate',
    failedCount: 'Failed Count',
    recipients: 'Recipients',
    reads: 'Reads',
    pushEnabled: 'Push',
    contentHelp: 'The message content that will be shown to users',
    imageUrlHelp: 'Optional image URL to display with the message',
    actionDataHelp: 'URL, screen name, or deep link data depending on action type',
    websiteUrl: 'Website URL',
    deeplinkUrl: 'Deep Link URL',
    appScreen: 'App Screen',
    membershipHelp: 'Select membership levels to target (leave empty for all)',
    scheduledHelp: 'Schedule message to be sent at a specific time',
    expiresHelp: 'Message will be hidden after this date',
    pushNotificationDetails: 'Push Notification Details',
    pushTitle: 'Push Title',
    pushBody: 'Push Body',
    actionTarget: 'Action Target',
    active: 'Active',
    validFrom: 'Valid From',
    validUntil: 'Valid Until'
  },
  filters: {
    search: 'Search',
    createdAfter: 'Created After',
    createdBefore: 'Created Before'
  },
  types: {
    announcement: 'Announcement',
    promotion: 'Promotion',
    system: 'System',
    personal: 'Personal',
    alert: 'Alert'
  },
  priorities: {
    low: 'Low',
    normal: 'Normal',
    high: 'High',
    urgent: 'Urgent'
  },
  statuses: {
    draft: 'Draft',
    scheduled: 'Scheduled',
    sent: 'Sent',
    failed: 'Failed',
    sendNow: 'Send Now'
  },
  targetTypes: {
    all: 'All Users',
    membership: 'By Membership',
    group: 'By Group',
    individual: 'Individual Users'
  },
  actionTypes: {
    none: 'None',
    url: 'Open URL',
    screen: 'Navigate to Screen',
    deeplink: 'Deep Link'
  },
  memberships: {
    standard: 'Standard',
    silver: 'Silver',
    gold: 'Gold',
    platinum: 'Platinum',
    vip: 'VIP'
  },
  sections: {
    content: 'Message Content',
    properties: 'Message Properties',
    targeting: 'Targeting',
    action: 'Action Configuration',
    delivery: 'Delivery Options',
    statistics: 'Delivery Statistics',
    timeline: 'Timeline'
  },
  create: {
    title: 'Create New Message',
    subtitle: 'Create a new message to send to your users',
    backToList: 'Back to Messages',
    contentSection: 'Message Content',
    propertiesSection: 'Message Properties',
    targetingSection: 'Target Audience',
    deliverySection: 'Delivery & Actions',
    schedulingSection: 'Scheduling',
  },
  notifications: {
    createSuccess: 'Message created successfully',
    updateSuccess: 'Message updated successfully',
    deleteSuccess: 'Message deleted successfully',
  },
  createHint: 'Create a new message to send to your users. Messages can be targeted to specific groups and include push notifications.',
  pushNotificationInfo: 'When push notification is enabled, users will receive a notification on their device that opens the message or navigates to the configured action.',
  pushNotEnabledMessage: 'Push notifications were not enabled for this message.',
  resendPushHelp: 'Use the checkbox below to resend push notifications when saving.',
  noExpiry: 'No expiry',
  imagePreview: 'Image Preview',
  clickToUpload: 'Click to upload or drag and drop',
  imageRequirements: 'PNG, JPG up to 5MB (will be cropped to 2:1 aspect ratio)',
  selectImage: 'Select Image',
  selectScreen: 'Select App Screen',
  appScreen: 'App Screen',
  notificationDetailInfo: 'This will open the message detail screen with the message content.',
  screenParams: 'Screen Parameters (JSON)',
  screenParamsHelp: 'Optional parameters to pass to the screen',
  actionHelp: {
    none: 'No action when message is opened',
    url: 'Open a website in the browser',
    screen: 'Navigate to a screen in the app',
    deeplink: 'Open a deep link URL'
  },
  urlHelp: 'Enter the full URL including https://',
  deeplinkHelp: 'Enter the deep link URL for your app',
  actionTargetValue: 'Action Target Value',
  errors: {
    invalidFileType: 'Invalid file type. Please upload PNG or JPG images.',
    fileTooLarge: 'File is too large. Maximum size is 5MB.',
    uploadFailed: 'Failed to upload image. Please try again.',
    imageUploaded: 'Image uploaded successfully'
  },
  editSentWarning: 'This message has been sent and cannot be edited. You can only view the details and statistics.',
  editSentInfo: 'This message has been sent. You can update the content and optionally resend the push notification to all recipients.',
  statistics: 'Statistics',
  actions: {
    send: 'Send Message',
    schedule: 'Schedule',
    cancel: 'Cancel',
    duplicate: 'Duplicate',
    preview: 'Preview',
    viewRecipients: 'View Recipients',
    resendNotification: 'Resend push notification to all recipients'
  },
  validation: {
    titleRequired: 'Title is required',
    contentRequired: 'Content is required',
    invalidUrl: 'Please enter a valid URL',
    scheduledDateInPast: 'Scheduled date cannot be in the past',
    expiryBeforeScheduled: 'Expiry date must be after scheduled date'
  },
  success: {
    created: 'Message created successfully',
    updated: 'Message updated successfully',
    sent: 'Message sent successfully',
    scheduled: 'Message scheduled successfully',
    deleted: 'Message deleted successfully',
    imageUploaded: 'Image uploaded successfully'
  },
  error: {
    sendFailed: 'Failed to send message',
    scheduleFailed: 'Failed to schedule message',
    loadFailed: 'Failed to load message'
  },
  multilang: {
    title: 'Multi-language Translations',
    helperText: 'Provide translations for your message in different languages. English is required, other languages are optional.',
    copyFromBasic: 'Copy from main text',
    translateFromSimplified: 'Translate from Simplified',
    translateFromTraditional: 'Translate from Traditional',
    titleHelperText: 'The title will be shown in the notification and message list',
    contentHelperText: 'The main message content that users will read',
    nonEnglishNote: 'Non-English translations are optional. If not provided, the English version will be used.'
  },
  appScreens: {
    Home: { name: 'Home Screen', description: 'Main app dashboard' },
    Chargers: { name: 'Chargers List', description: 'Browse all chargers' },
    ChargerDetail: { name: 'Charger Details', description: 'View specific charger' },
    Sites: { name: 'Sites List', description: 'Browse charging sites' },
    SiteDetail: { name: 'Site Details', description: 'View specific site' },
    Profile: { name: 'User Profile', description: 'User account settings' },
    PersonalInformation: { name: 'Personal Info', description: 'Edit personal details' },
    MyVehicles: { name: 'My Vehicles', description: 'Manage vehicles' },
    PaymentMethods: { name: 'Payment Methods', description: 'Manage payment cards' },
    ChargingHistory: { name: 'Charging History', description: 'View past sessions' },
    ChargingSession: { name: 'Active Session', description: 'Current charging session' },
    Notifications: { name: 'Notifications', description: 'All notifications' },
    NotificationDetail: { name: 'Notification Detail', description: 'View specific message' },
    Support: { name: 'Support', description: 'Help and support' },
    FAQ: { name: 'FAQ', description: 'Frequently asked questions' },
    About: { name: 'About', description: 'About the app' },
  }
};